import { useState } from "react";
import Button from "../../../../components/Button";
import Modal from '../../../../components/Modal'
import '../CartItem/CartItem.scss'
import FormBuy from "../../../../components/FormBuy/FormBuy";


const CartItem = ({product,title,url,color,id,price,removeFromCart}) =>{
const [buyModal, setBuyModal] = useState(false)
const [modalDelete,setModalDelete] = useState(false)
const deleteItem = () =>{
     removeFromCart(product)
     setModalDelete(false)
 
    
}
  const actions = 
  <div className="cart-item__actions">
        <Button className='cart-item__actions-button' onClick={deleteItem} text='Delete'/>
        <Button className='cart-item__actions-button' onClick={()=>{setModalDelete(false)}} text='Cancel'/>
  </div>


    return(
        <>
        <div className="cart-item__wrap">
            <div className="cart-item__img">
                <img src={url} alt={title} />
            </div>
            <div className="cart-item__content">
                <h2 className="cart-item__content-title">{title}</h2>
                <p className="cart-item__content-color">Color: {color}</p>
                <p className="cart-item__content-id">Product id: {id}</p>
            </div>
            <div className="cart-item__buy">
                <div className="cart-item__buy-wrapper">
                        <Button className='cart-item__buy-button--buy' onClick={()=>{setBuyModal(true)}} style = {{background : 'green'}} text='Buy Now'/>
                        {modalDelete && 
                        <Modal 
                        header='Do you want delete this product?'
                        text='This product will be delete from the cart.' 
                        btnClose={()=>{setModalDelete(false)}} 
                        actions={actions}/>
                        }
                        <p className="cart-item__buy-price">{price}$</p>
                        <Button className='cart-item__buy-button--close' onClick={()=>{setModalDelete(true)}} text ='X'/>
                        
                        {buyModal &&
                            <Modal 
                        header='Fill out the form to make a purchase'
                        text={<FormBuy onClick={deleteItem} submitBtnText='Check Out'/>} 
                        btnClose={()=>{setBuyModal(false)}} 
                        />
                        }
                </div>
            </div>
        </div>
        </>
    )
}

export default CartItem;